module.exports = __webpack_public_path__ + "static/media/test10_3.2d1fce2a.png";